import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import { FormattedCurrency } from '../../../../../components/formatted-currency';

// Constants functions a pseudo-error codes
export const ADD_FUNDING_ERROR = 'Invalid purchase amount.';
export const NEGATIVE_NUM_ERROR = "'Value' must be greater than or equal to '0'";

const getUIErrorMessage = (errorResponse, currencyCode) => {
  if (!errorResponse?.Message) {
    return messages.unknownErrorWithoutMessage;
  }

  if (errorResponse.Message.startsWith(ADD_FUNDING_ERROR)) {
    return {
      ...messages.minMaxFundingError,
      values: {
        min: <FormattedCurrency currencyCode={currencyCode} value={10} />,
        max: <FormattedCurrency currencyCode={currencyCode} value={10000} />,
      },
    };
  }

  if (errorResponse.Message.startsWith(NEGATIVE_NUM_ERROR)) {
    return {
      ...messages.amountCannotBeNegative,
    };
  }

  return errorResponse.Message;
};

/**
 * @param {object} props
 * @param {object} props.error - error object with information from the server
 * @param {string} props.currencyCode - currency code to display in the error message in the case of being necessary
 * @returns {JSX.Element}
 */
export const AddFundErrorMessage = ({ error, currencyCode }) => {
  const messageDescriptor = getUIErrorMessage(error, currencyCode);

  return <li>{typeof messageDescriptor === 'string' ? messageDescriptor : <FormattedMessage {...messageDescriptor} />}</li>;
};
